import React, { useEffect, useState } from 'react';
import {VerifyBankBodyWrapper} from './styled.jsx';
import PropTypes from 'prop-types';
import Header from '../header/index.jsx';
import { CreditBodyContent } from "./CreditBodyContent.jsx";
import { OBVOnlyBodyContent } from "./OBVOnlyBodyContent.jsx";
import { DebitBodyContent } from "./DebitBodyContent.jsx";
import { shallowEqual, useSelector } from 'react-redux';
import { STATUS_PROGRESS_LOADING } from '../../constants/status';
import LoadingProgress from '../loading/index.jsx';
import { useTranslation } from 'react-i18next';

export const BodyContent = (props) => {
  const {onClickClose, obvInfo} = props;
  const {txType} = obvInfo;
  const { t } = useTranslation();
  
  const [activeLoading, setActiveLoading] = useState(false);
  const [statusProgress, setStatusProgress] = useState(STATUS_PROGRESS_LOADING.START);
  const appStore = useSelector((state) => state, shallowEqual).app;
  const { isLoading } = appStore;

  // Create loading messages array from i18n
  const loadingMessages = [
    t('loading.message.processing'),
    t('loading.message.verifying')
  ];

  useEffect(() => {
    if (isLoading) {
      setActiveLoading(true);
      setStatusProgress(STATUS_PROGRESS_LOADING.START);
    } else {
      setStatusProgress(STATUS_PROGRESS_LOADING.FINISH);
    }
    return () => {
      setStatusProgress(STATUS_PROGRESS_LOADING.NONE);
    };
  }, [isLoading]);


  const renderBodyContent = () => {
    if (txType === 'CREDIT') {
      return (<CreditBodyContent {...props }/>);
    } else if (txType === 'VERIFY') {
      return (<OBVOnlyBodyContent { ...props }/>);
    } else {
      return (<DebitBodyContent { ...props }/>);
    };
  };

  return (
      <VerifyBankBodyWrapper>
        <div className='confirmationContent'>
          <Header onClickClose={onClickClose} />
          {renderBodyContent()}
          <LoadingProgress
            active={ activeLoading }
            messages={ loadingMessages }
            timeNextMessage={ 3000 }
            timeBackgroundRun={ 2000 }
            progress={ statusProgress }
            afterFinish={() => {
              setActiveLoading(false);
              setStatusProgress(STATUS_PROGRESS_LOADING.NONE);
            }}
          />
        </div>
      </VerifyBankBodyWrapper>
  );
};
BodyContent.propTypes = {
  /**
   * Data OBV info
   */
  obvInfo: PropTypes.object,
  /**
   * Back Merchant when user click close
   */
  onClickClose: PropTypes.func,
  /**
   * Return to the page you just called
   */
  setViewTC: PropTypes.func,
  handleConfirm: PropTypes.func,
};


export default BodyContent;
